import * as React from 'react';

export const DownArrowIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
    props: React.SVGProps<SVGSVGElement>
) => {
    return (
        <svg
            width='8'
            height='5'
            viewBox='0 0 8 5'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            {...props} // forward props like className
        >
            <path
                d='M7.25 0.75L4 4.25L0.75 0.75'
                stroke='white'
                strokeOpacity='0.5' // note camelCase in JSX
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
};
